var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.666 11.25H31.166L30.3461 9.57281C29.725 8.30231 28.4554 7.5 27.0665 7.5H16.9322C15.5433 7.5 14.2737 8.3025 13.6525 9.57281L12.8327 11.25H7.33268C5.30758 11.25 3.66602 12.9289 3.66602 15V33.75C3.66602 35.8211 5.30758 37.5 7.33268 37.5H36.666C38.6911 37.5 40.3327 35.8211 40.3327 33.75V15C40.3327 12.9289 38.6911 11.25 36.666 11.25ZM21.9993 31.875C17.9491 31.875 14.666 28.5171 14.666 24.375C14.666 20.2329 17.9491 16.875 21.9993 16.875C26.0495 16.875 29.3327 20.2327 29.3327 24.375C29.3327 28.5173 26.0495 31.875 21.9993 31.875Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c0b35328c6766fcf389c4b97a4eaa354.svg";
export { ForwardRef as ReactComponent };